// Display in new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


var newWindowWidth = $(window).width();
if (newWindowWidth < 750) {
// Footer Accordion
$(".footer-block__heading").click(function () {
   if ($(".footer-block__details-content").is(':visible')) {
      $(".footer-block__details-content").slideUp(500);
      $(".down").show();
      $(".up").hide();
    }
   if ($(this).next(".footer-block__details-content").is(':visible')) {
        $(this).next(".footer-block__details-content").slideUp(500);
        $(this).find(".down").show();
        $(this).find(".up").hide();
    } else {
        $(this).next(".footer-block__details-content").slideDown(500);
        $(this).find(".up").show();
        $(this).find(".down").hide();
    }
});
}  

// multicolumn - accordion
$(".abz_multicolumn_1 .ml_sec_title").click(function () {
   if ($(".abz_multicolumn_1 .multi_text").is(':visible')) {
      $(".abz_multicolumn_1 .multi_text").slideUp(500);
      $(".down1").show();
      $(".up1").hide();
    }
   if ($(this).next(".abz_multicolumn_1 .multi_text").is(':visible')) {
        $(this).next(".abz_multicolumn_1 .multi_text").slideUp(500);
        $(this).find(".down1").show();
        $(this).find(".up1").hide();
    } else {
        $(this).next(".abz_multicolumn_1 .multi_text").slideDown(500);
        $(this).find(".up1").show();
        $(this).find(".down1").hide();
    }
});


/* Grid Slider */
$(document).ready(function() {
    $('.main-carousel').flickity({
        cellAlign: 'left',
        contain: true
    }); 
});

document.querySelectorAll('.slide_grid_nav button').forEach(btn => {
    let anchor = btn.parentElement.parentElement.querySelector('.grid_slider_title');
    btn.addEventListener("click", function() {
        if(btn.hasAttribute('active')) return;
        const slideGrid = btn.parentElement.parentElement.querySelector('.slide_grid');
        if(!slideGrid) return;
        
        if(!anchor) anchor = slideGrid;
        anchor.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });

        setTimeout(() => {
            slideGrid.dataset.page = btn.dataset.page;
            window.dispatchEvent(new Event('resize')); 
        }, 1000);
        setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 2000);
        
        let activeBtn = document.querySelector('.slide_grid_nav button[active]');
        activeBtn.removeAttribute('active');
        btn.setAttribute('active', ''); 

    })
});


